import { createContext, useState, ReactNode, useEffect } from "react";

export const AdminLayoutContext = createContext<{
    isSidebarOpen: boolean;
    toggleSidebar: () => void;
}>({
    isSidebarOpen: true,
    toggleSidebar: () => { },
});

export const AdminLayoutProvider = ({ children }: { children: ReactNode }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        // Betöltés localStorage-ből, alapértelmezett: false (bezárva)
        const saved = localStorage.getItem("adminSidebarOpen");
        return saved !== null ? JSON.parse(saved) : false;
    });

    useEffect(() => {
        // Mentés localStorage-be
        localStorage.setItem("adminSidebarOpen", JSON.stringify(isSidebarOpen));
    }, [isSidebarOpen]);

    return (
        <AdminLayoutContext.Provider
            value={{
                isSidebarOpen,
                toggleSidebar: () => setIsSidebarOpen((prev: boolean) => !prev),
            }}
        >
            {children}
        </AdminLayoutContext.Provider>
    );
};
